var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoElevator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-elevator",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 28,
    height: 28,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M35.813,15.44h0V27a2.033,2.033,0,0,1-2.049,2.012H21.36A2.033,2.033,0,0,1,19.311,27V15.441h0a2.331,2.331,0,0,1,2.333-2.332V26.678H33.48V13.107a2.33,2.33,0,0,1,2.333,2.332Zm-12.31.02h8.117V13.126H23.5ZM30.54,10.3a.875.875,0,0,0,1.5.616l3.438-3.464a1.748,1.748,0,0,0-.01-2.474L34.238,6.219,32.29,8.181V2.6a.875.875,0,0,0-1.751,0v.053S30.54,10.3,30.54,10.3ZM19.674,7.988,20.9,6.736s1.938-1.983,1.938-1.983V10.3a.875.875,0,0,0,1.751,0v-.053s0-7.647,0-7.647a.875.875,0,0,0-1.5-.611L19.645,5.514a1.748,1.748,0,0,0,.03,2.474Zm8.213-.04s1.171,1.17,1.171,1.17V6.776s-1.8-1.8-1.8-1.8-1.181-1.182-1.181-1.182v2.34S27.887,7.947,27.887,7.947Z",
    transform: "translate(-13.562 -1.225)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoElevator);
export default __webpack_public_path__ + "static/media/ico-elevator.629812b0a67c21445306f9d9bc40b164.svg";
export { ForwardRef as ReactComponent };